<template>
  <span class="font-weight-bold">{{ formattedValue }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
    },
    mediaMinima: {
      type: Number,
      default: 7,
    },
    max: {
      type: Number,
      default: 10,
    },
    arredondamento: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val > this.max) {
        this.$emit("change", this.max);
      }
    },
  },
  created() {
    if (this.value > this.max) {
      this.$emit("change", this.max);
    }
  },
  computed: {
    valueAsNumberOrNull() {
      return !this.valueIsEmpty ? parseFloat(this.value, 10) : null;
    },
    valueIsEmpty() {
      return this.value === null || this.value === undefined || isNaN(this.value);
    },
    formattedValue() {
      if (this.valueIsEmpty) return "- - -";
      let val = parseFloat(this.value);
      if (this.arredondamento) {
        val = this.roundValue(val);
      }
      return val <= this.max ? Math.floor(val * 10) / 10 : this.max;
    },
  },
  methods: {
    roundValue(val) {
      const decimalPart = Math.round((val % 1) * 100) / 100;

      if (decimalPart >= 0.1 && decimalPart < 0.6) {
        return Math.floor(val) + 0.5;
      }

      if (decimalPart >= 0.6 && decimalPart <= 0.9) {
        return Math.ceil(val);
      }
      return val;
    },
  },
};
</script>
